import { render, staticRenderFns } from "./CommonAd.vue?vue&type=template&id=73b6d52c&scoped=true&"
import script from "./CommonAd.vue?vue&type=script&lang=js&"
export * from "./CommonAd.vue?vue&type=script&lang=js&"
import style0 from "./CommonAd.vue?vue&type=style&index=0&id=73b6d52c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b6d52c",
  null
  
)

export default component.exports